import { useEffect } from 'react'

import WashingMachinePartPageHeader from '@/components/pages/WashingMachinePart/List/PageHeader'
import WashingMachinePartTable from '@/components/pages/WashingMachinePart/List/Table'
import { WashingMachinePart } from '@/types'

import { useWashingMachineParts } from './WashingMachinePart.hooks'

const WashingMachineParts = () => {
  const {
    getAllWashingMachinePart,
    getWashingMachinePartsLoading,
    getWashingMachinePartsResponse,
    deleteWashingMachinePart,
  } = useWashingMachineParts()

  const handleWashingMachinePart = async (id: WashingMachinePart['id']) => {
    await deleteWashingMachinePart({ id })
    getAllWashingMachinePart()
  }

  useEffect(() => {
    getAllWashingMachinePart()
  }, [getAllWashingMachinePart])

  return (
    <>
      <WashingMachinePartPageHeader />
      <WashingMachinePartTable
        {...{
          dataSource: getWashingMachinePartsResponse,
          getWashingMachinePartLoading: getWashingMachinePartsLoading,
        }}
        onDelete={handleWashingMachinePart}
      />
    </>
  )
}

WashingMachineParts.displayName = 'WashingMachineParts'
export default WashingMachineParts
